import { useMemoizedFn } from 'ahooks';
import { IGroupProp } from '@/utils/ctype';
import Blocker from '../../../components/Blocker';
import GroupTitle from '../../../components/GroupTitle';
import SubTitle from '../../../components/SubTitle/index';
import ChoiceQuestion from '../../../question/Question/ChoiceQuestion';
import MultipleChoiceQuestion from '../../../question/Question/MultiChoiceQuestion';
import MultipleQuestion from '../../../question/Question/MultipleQuestion';
import Table from '../../../question/Question/Table';
import Completion from '../../../question/Question/Completion';
import SentenceCompletion from '../../../question/Question/SentenceCompletion';
import PictureCompletion from '../../../question/Question/PictureCompletion';
import PictureMatchingQuestion from '../../../question/Question/PictureMatchingQuestion';
import MatchingQuestion from '../../../question/Question/MatchQuestion';
import MatchQuestionAI from '../../../question/AIQuestion/MatchQuestionAI';
import style from './index.module.less';

export default function Group(props:IGroupProp) {
  const {data, currentFocus, saveAnswerHandle, answerMap, loadAnswered, pageData, isAI, index: keyIndex, setShowDragFieldHandle, setFocusIndexHandle, feedbackMap, displayAnswerMap } = props;
  const {desc, type, list = [], group_id, title} = data || {};
  const { answerAllText = []} = pageData;

  const createQuestions = useMemoizedFn((type: number) => {
    switch (type) {
      case 1: 
        return (
          <>
            <GroupTitle title={title} align="left" />
            { data.img_url ? <img style={{ maxWidth: '400px' }} src={data.img_url} /> : null }
            <div className={style.listWrap}>
              {
                list.map((item, index: number) => {
                  return <ChoiceQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} className={style.full} type={type} data={item} groupId={group_id} key={item.id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></ChoiceQuestion>;
                })
              }
            </div>
          </>
        );
      case 2: 
        return <MultipleQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></MultipleQuestion>;
      case 3:
        return <>
          <Table displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></Table>
        </>;
      case 4:
        return (
          <div >
            {
              list.map((item, index: number) => {
                return <Completion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={item} groupId={group_id} key={item.id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></Completion>;
              })
            }
          </div> 
        );
      case 5: 
        return <>
          <Blocker>
            <GroupTitle title={title} />
            <SentenceCompletion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></SentenceCompletion>
          </Blocker>
        </>;
      case 6: 
        return <>
          <PictureCompletion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></PictureCompletion>
        </>;
      case 7 :
        return <>
          <PictureMatchingQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle}></PictureMatchingQuestion>
        </>;
      case 8:
        if (!isAI) {
          return <MatchingQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus}
            saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} pageData={pageData} loadAnswered={loadAnswered}
            isAI={isAI} keyIndex={keyIndex} setShowDragFieldHandle={setShowDragFieldHandle} setFocusIndexHandle={setFocusIndexHandle}></MatchingQuestion>;
        } else {
          return <MatchQuestionAI displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} type={type} data={data} groupId={group_id} currentFocus={currentFocus}
            saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} loadAnswered={loadAnswered}
            isAI={isAI} isListen={true} keyIndex={keyIndex} answerAllText={answerAllText}
          ></MatchQuestionAI>;
        }
      case 9: {
        return (
          <>
            <GroupTitle title={title} />
            { data.img_url ? <img src={data.img_url} /> : null }
            <div className={style.listWrap}>
              {
                list.map((item, index: number) => {
                  return <MultipleChoiceQuestion displayAnswerMap={displayAnswerMap} feedbackMap={feedbackMap} className={style.half} type={type} data={item} groupId={group_id} key={item.id} currentFocus={currentFocus} saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} isAI={isAI} isListen={true} keyIndex={keyIndex} index={index} answerAllText={answerAllText} setFocusIndexHandle={setFocusIndexHandle} />;
                })
              }
            </div>
          </>
        );
      }
    }
  });

  return (
    <>
      <SubTitle desc={desc} keyIndex={keyIndex}></SubTitle>
      <div className={style.answerGroup}>
        {createQuestions(type)}
      </div> 
    </>
  );
}
